import React, { useState, useEffect } from 'react';
import axios from 'axios';
import $ from 'jquery';
import api from '../../api/axiosInstance';
function Settings() {
    const [emailServer, setEmailServer] = useState('');
    const [emailPort, setEmailPort] = useState('');
    const [emailUser, setEmailUser] = useState('');
    const [emailPassword, setEmailPassword] = useState('');
    const [allowSendingEmails, setAllowSendingEmails] = useState('Yes');

    // Fetch settings data
    const fetchSettings = async () => {
        try {
            const response = await api.get('/Administration/ViewSettings');
            const settingsArray = response.data;

            // Map settings to state variables
            settingsArray.forEach(setting => {
                switch (setting.name) {
                    case 'EMAILSERVER':
                        setEmailServer(setting.value);
                        break;
                    case 'EMAILPORT':
                        setEmailPort(setting.value);
                        break;
                    case 'EMAILUSER':
                        setEmailUser(setting.value);
                        break;
                    case 'EMAILPASSWORD':
                        setEmailPassword(setting.value);
                        break;
                    case 'EMAILFLAG':
                        setAllowSendingEmails(setting.value === 'yes' ? 'Yes' : 'No');
                        break;
                    default:
                        break;
                }
            });
        } catch (error) {
            console.error('Error fetching settings:', error);
        }
    };

    // Fetch settings on component mount
    useEffect(() => {
        fetchSettings();
    }, []);

    const handleSubmit = async (event) => {
        event.preventDefault();

        const settingsData = [
            { name: "EMAILFLAG", value: allowSendingEmails === 'Yes' ? 'yes' : 'no' },
            { name: "EMAILPASSWORD", value: emailPassword },
            { name: "EMAILPORT", value: emailPort },
            { name: "EMAILSERVER", value: emailServer },
            { name: "EMAILUSER", value: emailUser },
        ];

        $.confirm({
            title: 'Confirm Save',
            content: 'Do you really want to save these settings?',
            buttons: {
                cancel: {
                    text: 'Cancel',
                    btnClass: 'btn-red',
                    action: function () {
                        // Do nothing on cancel
                    }
                },
                confirm: {
                    text: 'Yes, save it!',
                    btnClass: 'btn-green',
                    action: async function () {
                        try {
                            // Call your API to save the settings
                            await api.post('/Administration/SaveSettings', settingsData);

                            // Success alert
                            $.alert({
                                title: 'Success!',
                                content: 'Settings saved successfully!',
                                type: 'green',
                                buttons: {
                                    okay: {
                                        text: 'Ok',
                                        btnClass: 'btn-green',
                                        action: function () {
                                            // Optionally refresh settings or do other actions
                                            fetchSettings(); // Refresh the settings after saving
                                        }
                                    }
                                }
                            });
                        } catch (error) {
                            console.error('Error saving settings:', error);
                            $.alert({
                                title: 'Error!',
                                content: 'Error saving settings. Please try again.',
                                type: 'red',
                            });
                        }
                    }
                }
            }
        });
    };

    return (
        <div className="card card-success">
            <div className="card-header">
                <h3 className="card-title">Settings</h3>
            </div>
            <div className="card-body">
                <form role="form" onSubmit={handleSubmit}>
                    <div className="row">
                        <div className="col-sm-3">
                            <div className="form-group">
                                <label>Email Server</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={emailServer}
                                    onChange={(e) => setEmailServer(e.target.value)}
                                    required
                                />
                            </div>
                        </div>
                        <div className="col-sm-3">
                            <div className="form-group">
                                <label>Email Port</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={emailPort}
                                    onChange={(e) => setEmailPort(e.target.value)}
                                    required
                                />
                            </div>
                        </div>
                        <div className="col-sm-3">
                            <div className="form-group">
                                <label>Email User</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={emailUser}
                                    onChange={(e) => setEmailUser(e.target.value)}
                                    required
                                />
                            </div>
                        </div>
                        <div className="col-sm-3">
                            <div className="form-group">
                                <label>Email Password</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={emailPassword}
                                    onChange={(e) => setEmailPassword(e.target.value)}
                                    required
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-3">
                            <div className="form-group">
                                <label>Allow Sending Emails?</label>
                                <select
                                    className="form-control"
                                    value={allowSendingEmails}
                                    onChange={(e) => setAllowSendingEmails(e.target.value)}
                                    required
                                >
                                    <option value="Yes">Yes</option>
                                    <option value="No">No</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="card-footer">
                        <button type="submit" className="btn btn-success">Save</button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default Settings;
